import PropTypes from 'prop-types';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';

const CustomAlert = ({ headerText, bodyText, onClose }) => (
	<Alert severity='success' sx={{ mb: 3 }} onClose={onClose}>
		<Typography fontWeight={700}>{headerText}</Typography>
		<Typography>{bodyText}</Typography>
	</Alert>
);

export default CustomAlert;

CustomAlert.defaultProps = {
	onClose: () => null,
};

CustomAlert.propTypes = {
	headerText: PropTypes.string.isRequired,
	bodyText: PropTypes.string.isRequired,
	onClose: PropTypes.func,
};
